var SENTRY_RELEASE;SENTRY_RELEASE={name: "Sparrow", version: "1.1.6"};